<template>
  <div class="field-option-customer-info-wrapper">
    <div class="top-hair" />
    <div class="field-option-wrapper">
      <div class="text-input-wrapper">
        <field-option-customer-info-shape-picker
          :items="shapes"
          @change="$event => handleFieldChange('shape', $event)"
        />
        <field-option-customer-info-input
          v-if="isshow"
          placeholder="请输入姓名"
          @change="$event => handleFieldChange('name', $event)"
        />
        <div class="identify">
          <van-dropdown-menu direction="up">
            <van-dropdown-item
              v-model="idValue"
              :options="option"
              @change="handleId"
            />
          </van-dropdown-menu>
          <field-option-customer-info-input
            v-if="isshow"
            :maxlength="18"
            width="100rpx"
            placeholder="请输入证件号码"
            @change="$event => handleFieldChange('identityNo', $event)"
          />
        </div>
      </div>
      <div class="face-image-wrapper" v-if="isface">
        <field-option-customer-info-face-uploader
          @change="$event => handleFieldChange('face', $event)"
        />
      </div>
    </div>
    <div class="bottom-hair" />
  </div>
</template>
<script>
import Vue from 'vue';
import { DropdownMenu, DropdownItem } from 'vant';
import FieldOptionCustomerInfoInput from './FieldOptionCustomerInfoInput.vue';
import FieldOptionCustomerInfoShapePicker from './FieldOptionCustomerInfoShapePicker.vue';
import FieldOptionCustomerInfoFaceUploader from './FieldOptionCustomerInfoFaceUploader.vue';

Vue.use(DropdownMenu);
Vue.use(DropdownItem);
export default {
  components: {
    FieldOptionCustomerInfoInput,
    FieldOptionCustomerInfoShapePicker,
    FieldOptionCustomerInfoFaceUploader,
  },
  props: {
    shapes: [Array],
  },
  data() {
    return {
      value: {},
      isshow: true,
      isface: false,
      idValue: 0,
      option: [
        {
          text: '大陆居民身份证',
          value: 0,
        },
        {
          text: '港澳台身份证',
          value: 1,
        },
        {
          text: '护照',
          value: 2,
        },
        {
          text: '外国人永久居住证',
          value: 3,
        },
      ],
    };
  },
  methods: {
    handleFieldChange(key, val) {
      if (key === 'shape') {
        if (val.required === 0) {
          this.isshow = false;
        } else {
          this.isshow = true;
        }
        if (val.face === 1) {
          this.isface = true;
        } else {
          this.isface = false;
        }
      }
      this.value[key] = val;
      this.$emit('change', this.value);
    },
    handleId() {
      this.$emit('handleId', this.idValue);
    },
  },
};
</script>
<style lang="less" scoped>
.field-option-customer-info-wrapper {
  .top-hair {
    border-top: 1px dashed #eee;
    margin: 0 16px;
  }

  &:last-child {
    .bottom-hair {
      border-top: 1px dashed #eee;
      margin: 0 16px;
    }
  }

  .field-option-wrapper {
    display: flex;

    .text-input-wrapper {
      flex: 1;

      .identify {
        display: flex;

        /deep/ .van-dropdown-menu__bar {
          box-shadow: none;

          /deep/ .van-dropdown-menu__title {
            font-size: 20rpx;
          }

          /deep/ .van-dropdown-menu__title::after {
            right: 0;
          }
        }
      }
    }

    .face-image-wrapper {
      display: flex;
      z-index: 1;
      margin-right: 8px;
      align-items: center;
    }
  }
}
</style>
